import { render, staticRenderFns } from "./proforma.vue?vue&type=template&id=e8b1f730&scoped=true&"
import script from "./proforma.vue?vue&type=script&lang=js&"
export * from "./proforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b1f730",
  null
  
)

export default component.exports